module.exports = __webpack_public_path__ + "static/media/evening-photo-product.aa945189.jpg";